"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Routes = void 0;
var Routes = /** @class */ (function () {
    function Routes() {
    }
    Routes.slides = 'Slides';
    Routes.productSearch = 'ProductSearch';
    Routes.productDetail = 'ProductDetail';
    Routes.bookMarkedProducts = 'BookMarkedProducts';
    Routes.productDetailTest = 'ProductDetailTest';
    Routes.productDatasheet = 'ProductDatasheet';
    return Routes;
}());
exports.Routes = Routes;
